import type {PhoneInputWidgetConfig} from '../../types'
import {PhoneInput} from '@yandex-delivery/form/ui/OrderForm/components/Input/PhoneInput'

export const PhoneInputWidget = ({height, placeholder, form_state_key}: PhoneInputWidgetConfig): React.ReactElement => {
  return <PhoneInput name={form_state_key} height={height} placeholder={placeholder} />
}
